import { render } from "./Emojis.vue?vue&type=template&id=350c94fa"
import script from "./Emojis.vue?vue&type=script&lang=ts"
export * from "./Emojis.vue?vue&type=script&lang=ts"
script.render = render

export default script